/**
 * @file AnimationBase
 * @author Yu Zong(liuxuanzy@qq.com)
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Emitter } from '@tencent/glue-util-emitter';
var AnimationBase = /** @class */ (function (_super) {
    __extends(AnimationBase, _super);
    function AnimationBase(options) {
        var _this = _super.call(this) || this;
        _this.executor = null;
        _this.options = options;
        return _this;
    }
    AnimationBase.prototype.setExecutor = function (executor) {
        var _this = this;
        if (this.executor && this.executor !== executor) {
            throw new Error('you must pass this animation to the same property of the  same component');
        }
        this.executor = executor;
        executor.setCallbacks({
            onAnimationStart: function () { return _this.emit('start'); },
            onAnimationEnd: function () { return _this.emit('end'); },
            onAnimationCancel: function () { return _this.emit('cancel'); },
            onAnimationRepeat: function () { return _this.emit('repeat'); },
        });
    };
    AnimationBase.prototype.getOptions = function () {
        return this.options;
    };
    AnimationBase.prototype.start = function () {
        if (!this.executor) {
            throw new Error('you must pass animation to the style property of the preset component');
        }
        this.executor.start();
    };
    AnimationBase.prototype.pause = function () {
        if (!this.executor) {
            throw new Error('you must pass animation to the style property of the preset component');
        }
        this.executor.pause();
    };
    AnimationBase.prototype.resume = function () {
        if (!this.executor) {
            throw new Error('you must pass animation to the style property of the preset component');
        }
    };
    AnimationBase.prototype.dispose = function () {
        if (!this.executor) {
            throw new Error('you must pass animation to the style property of the preset component');
        }
        this.executor.dispose();
    };
    return AnimationBase;
}(Emitter));
export { AnimationBase };
